import React, { useContext, useEffect } from 'react'
import {HeadTableLeads, LeadsForAssign, RowLeadsforAssign } from "../../ui-components";
import LeadsContext from '../../context/leads';

function ForAssignTable({onToggleTab,setAssignLead, order}) {
  const {Leadslist,models, Subs, toggle} = useContext(LeadsContext)
  
  useEffect(()=>{
    Leadslist(0, order, "register");
    Subs();
  },[order, toggle])
  
  console.log(toggle);
  return (
    <div className="overflow-x-scroll py-2">
   <HeadTableLeads type="forAssign"/>
   {/* <LeadsForAssign overrideItems={overridesForAssign}/>*/}
   {models?.map((lead, index) => (
    index % 2 == 0 ?
    <RowLeadsforAssign key={lead.id} Lead={lead} overrides={{ 
      Button:{
      onClick: () =>{
        onToggleTab(5)
        setAssignLead(lead)
      }
    }}}/> :
    <RowLeadsforAssign key={lead.id} Lead={lead} overrides={{ 
      Button:{
      onClick: () =>{
        onToggleTab(5)
        setAssignLead(lead)
      }
    },
    "Frame 20797":{backgroundColor: "#ffffff"}}}/>
   ))}
  </div>

  )
}

export default ForAssignTable